export const balanceNotificationActive = 'balance-notification-active';
export const balanceNotificationInput = 'balance-notification';
export const winningBetsNotificationActive = 'winning-bets-notification-active';

export const mapPayloadKeyToFieldName = {};

export const balanceCommunicationsId = 1;
export const winningBetsCommunicationsId = 2;
